import React, {createContext, useCallback, useContext, useRef, useState} from 'react'

type TState = {
    allSelected: boolean
    toggleAll: () => void
}

// Стабильный контекст только для publish — CheckboxDropdown не ре-рендерится при изменении state
const CheckboxDropdownPublishContext = createContext<((state: TState) => void) | null>(null)

// Контекст состояния — только для CheckboxDropdownSelectAll в лейбле
const CheckboxDropdownStateContext = createContext<TState | null>(null)

export const CheckboxDropdownProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    const [state, setState] = useState<TState | null>(null)
    const toggleAllRef = useRef<(() => void) | null>(null)

    const publish = useCallback((incoming: TState) => {
        toggleAllRef.current = incoming.toggleAll
        setState((prev) => {
            if (prev?.allSelected === incoming.allSelected) return prev
            return {
                allSelected: incoming.allSelected,
                toggleAll: () => toggleAllRef.current?.(),
            }
        })
    }, [])

    return (
        <CheckboxDropdownPublishContext.Provider value={publish}>
            <CheckboxDropdownStateContext.Provider value={state}>
                {children}
            </CheckboxDropdownStateContext.Provider>
        </CheckboxDropdownPublishContext.Provider>
    )
}

export const useCheckboxDropdownPublish = () => useContext(CheckboxDropdownPublishContext)
export const useCheckboxDropdownState = () => useContext(CheckboxDropdownStateContext)